/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ask_IndustryInputs */



/**
* | output |
* | --- |
* | "Which industry do you work in?" |
*
* @param {Onboarding_Ask_IndustryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_ask_industry = /** @type {((inputs?: Onboarding_Ask_IndustryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ask_IndustryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In welcher Branche arbeitest du?")
	return /** @type {LocalizedString} */ ("Which industry do you work in?")
});